<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query.no" clearable placeholder="business.label.no" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="query.name" clearable placeholder="business.label.name" size="small" type="search" @search-click="refresh"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.vehicleNo"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.vehicleName"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="mnemonicCode" title="business.label.mnemonicCode"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="type" title="business.label.vehicleType"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="category" title="business.label.category"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="weight" title="business.label.weight"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="fullload" title="business.label.fullload"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="status" title="business.label.status"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="owner" title="business.label.ownerEnterprise"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="driver" title="business.label.driver"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="dispatched" title="business.label.vehicleDispatched" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { findAll, saveAll } from '@/api/Api'
import { Vehicle } from '@/api/dto/common/Vehicle'

export default {
  name: 'VehicleDataMaintain',
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      query: new Vehicle(),
      contentSize: 0,
      page: 1,
      size: 15,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ]
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('vehicleFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new Vehicle(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.data.push(new Vehicle())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('vehiclePersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>